import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { ISkuData } from "common/records/Sku";

export const FETCH_SKU = "@skus/FETCH_SKU";
export const RECEIVE_SKU = "@skus/RECEIVE_SKU";
export const SET_LOADED = "@skus/SET_LOADED";
export const UPDATE_FORM = "@skus/UPDATE_FORM";
export const CLEAR_SKU = "@skus/CLEAR_SKU";
export const UPDATE_VALUE = "@skus/UPDATE_VALUE";
export const RESET_SKU = "@skus/RESET_SKU";

export const SkuActions = {
  fetchSku: (id: number) => createAction(FETCH_SKU, { id }),
  receiveSku: (sku: ISkuData) => createAction(RECEIVE_SKU, { sku }),
  setLoaded: (id: number) => createAction(SET_LOADED, { id }),
  update: (event: any) => createAction(UPDATE_FORM, { event }),
  clearSku: (id: number) => createAction(CLEAR_SKU, { id }),
  updateValue: (id: number, newValue: string) => createAction(UPDATE_VALUE, { id, newValue }),
  resetSku: (skuId: number) => createAction(RESET_SKU, { skuId }),
};

export type SkuActions = ActionsUnion<typeof SkuActions>;
